<fq-chart [configuration]="chartConfig" [colorPalette]="colorPalette" [data]="chartData"></fq-chart>
